import { Box, Button, Divider, Grid, Stack } from "@mui/material";
import { ControlledAutocomplete, DataLayout, FieldControl, FileUpload } from "../../../shared/components";
import { useRaiseQuery } from "../hooks/useRaiseQuery";
import { useDisplayField } from "../../../hooks/useDisplayField";

export const RaiseQuery: React.FC<{ id: null | string; projectId: string | undefined; editStatus: boolean; onSaved: () => void; onClose: () => void }> = ({ id, projectId, editStatus, onSaved, onClose }) => {
   
    const { getFilterOptions } = useDisplayField([]);
    const { query, userOptions, isLoadingUsers, isPending, fileUploadRef, phaseData, handleUpdate, onSave } = useRaiseQuery({ id, projectId, editStatus });

    return (
        <Box display={'flex'} flexDirection={'column'} gap={2} height={'100%'} overflow={'hidden'}>
            <Box flex={1} sx={{ overflowY: 'auto' }} p={2}>
                <Box display={'flex'} flexDirection={'column'} gap={2}>

                    <FieldControl
                        keyName={'type'}
                        label={"Query Type"}
                        variant={"select"}
                        options={[
                            { label: 'Project', value: 'Project' },
                            { label: 'Portfolio', value: 'Portfolio' },
                            { label: 'Programme', value: 'Programme' },
                        ]}
                        value={query.type}
                        onChange={handleUpdate}
                    />

                    {
                        query.type === 'Project' &&
                        <ControlledAutocomplete
                            type="PROJECT"
                            value={query.project}
                            onSelect={(val) => handleUpdate('project', val)}
                            label="Search project"
                            placeholder="Search project"
                        />
                    }

                    {
                        query.type === 'Project' &&
                        <FieldControl
                            keyName={'phase'}
                            label={"Select Project Phase"}
                            variant={"select"}
                            value={query.phase}
                            options={
                                phaseData.data?.data?.map((value: { id: string, name: string; }) => {
                                    return {
                                        value: value.id, label: value.name
                                    }
                                })
                            }
                            onChange={handleUpdate}
                            loading={phaseData.isPending}
                        />
                    }

                    {
                        query.type === 'Portfolio' &&
                        <ControlledAutocomplete
                            type="PORTFOLIO"
                            value={query.portfolio}
                            onSelect={(val) => handleUpdate('portfolio', val)}
                            label="Search portfolio"
                            placeholder="Search portfolio"
                        />
                    }

                    {
                        query.type === 'Programme' &&
                        <ControlledAutocomplete
                            type="PROGRAMME"
                            value={query.programme}
                            onSelect={(val) => handleUpdate('programme', val)}
                            label="Search programme"
                            placeholder="Search programme"
                        />
                    }

                    <Divider />

                    <FieldControl
                        keyName={'title'}
                        label={"Query Title"}
                        variant={"input"}
                        value={query.title}
                        onChange={handleUpdate}
                    />

                    <FieldControl
                        keyName={'description'}
                        label={"Description"}
                        variant={"input"}
                        value={query.description}
                        onChange={handleUpdate}
                    />

                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <FieldControl
                                keyName={'category'}
                                label={"Query Type"}
                                variant={"select"}
                                options={getFilterOptions('QUERY_CATEGORY').map((value) => {
                                    return {
                                        label: value.display_text,
                                        value: value.key
                                    }
                                })}
                                value={query.category}
                                onChange={handleUpdate}
                            />
                        </Grid>
                        <Grid size={6}>
                            <FieldControl
                                keyName={'priority'}
                                label={"Priority"}
                                variant={"select"}
                                options={getFilterOptions('QUERY_PRIORITY').map((value) => {
                                    return {
                                        label: value.display_text,
                                        value: value.key
                                    }
                                })}
                                value={query.priority}
                                onChange={handleUpdate}
                            />
                        </Grid>
                    </Grid>

                    <FieldControl
                        keyName={'assigned'}
                        label={"Assigned to"}
                        variant={"select"}
                        options={userOptions}
                        loading={isLoadingUsers}
                        value={query.assigned}
                        onChange={handleUpdate}
                    />

                    <DataLayout title="Attachments" bgVariant="filled">
                        <Box p={2}>
                            <FileUpload
                                type={"queries"}
                                ref={fileUploadRef}
                                onUploadComplete={() => { onSaved() }}
                                typeId={id}
                            />
                        </Box>
                    </DataLayout>

                </Box>
            </Box>
            <Stack direction="row" spacing={2} justifyContent="flex-end" flexShrink={0} bgcolor={'action.hover'} p={2}>
                <Button onClick={onClose} variant="outlined" loading={isPending} disabled={isPending}>Cancel</Button>
                <Button onClick={onSave} variant="contained" loading={isPending} disabled={isPending}>Save</Button>
            </Stack>
        </Box>
    )

}